import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

// Pages
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import CheckoutPage from "@/pages/CheckoutPage";
import DashboardPage from "@/pages/DashboardPage";
import BuyPage from "@/pages/BuyPage";
import HomesPage from "@/pages/HomesPage";
import AutoPage from "@/pages/AutoPage";
import MarketsPage from "@/pages/MarketsPage";
import WealthPage from "@/pages/WealthPage";
import CapitalPage from "@/pages/CapitalPage";
import WalletPage from "@/pages/WalletPage";
import ProfilePage from "@/pages/ProfilePage";
import PartnerDashboard from "@/pages/PartnerDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          
          {/* Protected routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute><DashboardPage /></ProtectedRoute>
          } />
          <Route path="/buy" element={
            <ProtectedRoute><BuyPage /></ProtectedRoute>
          } />
          <Route path="/homes" element={
            <ProtectedRoute><HomesPage /></ProtectedRoute>
          } />
          <Route path="/auto" element={
            <ProtectedRoute><AutoPage /></ProtectedRoute>
          } />
          <Route path="/markets" element={
            <ProtectedRoute><MarketsPage /></ProtectedRoute>
          } />
          <Route path="/wealth" element={
            <ProtectedRoute><WealthPage /></ProtectedRoute>
          } />
          <Route path="/capital" element={
            <ProtectedRoute><CapitalPage /></ProtectedRoute>
          } />
          <Route path="/wallet" element={
            <ProtectedRoute><WalletPage /></ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute><ProfilePage /></ProtectedRoute>
          } />
          <Route path="/partner" element={
            <ProtectedRoute><PartnerDashboard /></ProtectedRoute>
          } />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
